import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
     CHECK_SPLIT_TEMPLATE_REQUEST,
  CHECK_SPLIT_TEMPLATE_SUCCESS,
  CHECK_SPLIT_TEMPLATE_FAILURE,
  CHECK_SPLIT_TEMPLATE_LOADING,
  CHECK_SPLIT_TEMPLATE_RESET,
}= therapyPlanningAction

function* checkSplitMinPlanner(action: any): SagaReturnType<any> {
  try {

    yield put({type:CHECK_SPLIT_TEMPLATE_LOADING})
    const response = yield call(
      therapyPlanningService.checkSplitMinInPlanner,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: CHECK_SPLIT_TEMPLATE_SUCCESS,
        payload: response.data,
        requestedPayload:action.payload?.requestPayload,
        sourceTemp:action.payload?.sourceTemp
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type:CHECK_SPLIT_TEMPLATE_FAILURE ,
      payload: error,
    });
  }
}

function* checkSplitMinPlannerSaga() {
  yield takeEvery(
    CHECK_SPLIT_TEMPLATE_REQUEST,
    checkSplitMinPlanner
  );
}

export default checkSplitMinPlannerSaga;
